import { baseApiAddresses, getOldUIPath, openOldUI } from './urls';
import { clearToken, getToken, setToken } from './token';
import { updateOfflineStatus } from './offline';

// eslint-disable-next-line import/prefer-default-export
export default function initWindow() {
  window.getBaseApiAddresses = function () {
    return baseApiAddresses[process.env.HOTELMEISTER_ENV];
  };
  window.getToken = getToken;
  window.clearToken = clearToken;
  window.setToken = setToken;
  window.openOldUI = openOldUI;
  window.getOldUIPath = getOldUIPath;

  window.hmOffline = false;

  window.onoffline = updateOfflineStatus;
  window.ononline = updateOfflineStatus;

  window.HmVue = {
    instances: [],
    getAppInstance: function (name) {
      return this.instances[name];
    },
    getInstance: function (name) {
      return this.instances[name].$children[0];
    },
  };
}



// WEBPACK FOOTER //
// ./src/lib/util/window.js